<script lang="ts">

import { onMount } from "svelte";
import { homeAnchor, loadPagePromise, slickScrollInstance } from "../store";
import anime from "animejs";
import { loadImage } from "../utils";

let homeContainer; // Container
let backgroundContainer, backgroundImage; // Offsets
let path1, path2, path3, path4; // SVG Paths
let titleWord1, titleWord2, shortDetails, callToAction; // Elements for animations

onMount(async () => {

	await loadPagePromise;
	$homeAnchor = homeContainer;

	// Add scroll offsets to slickScroll
	$slickScrollInstance.addOffset({
		element: backgroundContainer,
		speedY: 0.8
	});

	introAnimation();
})


// Page load animations
function introAnimation() {
	
	let animation = [{ strokeDashoffset: '0' }];

	// Signature animation using svg strokDashOffset
	path1.animate(animation, {
		duration: 4000,
		delay: 20,
		easing: 'cubic-bezier(.72,.3,.25,1)',
		fill: 'forwards'
	}); 
	

	// Animate background image
	Object.assign(backgroundContainer.style, {
		height: "0",
		transform: "scale(1.3)",
	});
	backgroundImage.style.transform = "translateY(80%) scale(1.4)";

	anime({
		targets: backgroundContainer,
		height: "100%",
		scale: 1,
		easing: "cubicBezier(0.165, 0.84, 0.44, 1)",
		duration: 1500,
		delay: 2000,
		complete: () => {
			backgroundContainer.style.boxShadow = "3px 9px 18px rgba(0, 0, 0, 0.2)";
		}
	});
	anime({
		targets: backgroundImage,
		translateY: "0",
		scale: 1,
		easing: "cubicBezier(0.165, 0.84, 0.44, 1)",
		duration: 1500,
		delay: 2000
	});


	// Animate title
	let titleElems = [titleWord1, titleWord2, shortDetails, callToAction];
	titleElems.forEach(e => {
		e.style.transform = "translateY(-150%) rotate(-8deg)";
	})
	anime({
		targets: titleElems,
		rotate: "0",
		translateY: "0%",
		easing: "cubicBezier(0.165, 0.84, 0.44, 1)",
		duration: 2400,
		delay: anime.stagger(80, {start: 2500})
	});
}

</script>

<div id="content-container" style="padding-top: 23vh" bind:this={homeContainer}>
	<div class="content-wrapper">
		<div class="flex">
			<div class="flex-wrapper first">
				<svg id="signature" class="h-signature" width="503" height="269" viewBox="0 0 503 269" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path 
						bind:this={path1}
						class="path-1"
						style="fill:none;stroke:#ffffff;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-opacity:1;stroke-miterlimit:4;"
						d="M61.5 268L135.5 68.5C154.333 124.5 189.4 236.7 179 237.5C166 238.5 64 187.5 10 196C-44 204.5 219.5 139.5 219.5 133.5C219.5 128.7 224.833 134.167 227.5 137.5L219.5 180C217.833 187.833 214.6 204.5 215 208.5C215.5 213.5 239 147 245 150.5C251 154 230.5 155 257 142.5C283.5 130 268 191.5 269.5 196C271 200.5 272.5 237 281 232.5C289.5 228 290 233.5 313.5 192C337 150.5 328 120 325.5 104C323 88 344 142.5 343.5 142.5C343 142.5 373.5 196 375 196C376.2 196 375.5 204.333 375 208.5C371.667 211.5 363.8 217.2 359 216C353 214.5 339.777 221 325.5 208.5C311.223 196 355.5 163.5 390.5 111.5C418.5 69.9 423.833 37.1667 423 26C419.5 17 411.9 -0.100001 409.5 3.5C406.5 8 403.5 15 404.5 20.5C405.3 24.9 413.5 78 417.5 104V208.5C429.667 163.833 459.3 80.4 480.5 104C501.7 127.6 501.667 164.5 499 180"/>
				</svg>
			</div>
			
			<div class="flex-wrapper second">
				<h1 class = "title">
					<div class="title-mask">
						<div class="word" bind:this={titleWord1}>Ansh</div>
					</div><br> 
					<div class="title-mask">
						<div class="word" bind:this={titleWord2}>Choudhary</div>
					</div>
				</h1>
				<div class="occupation mask">
					<p class = "paragraph" bind:this={shortDetails}>
						CSE Student based in Dubai | front-end web developer
					</p>
				</div>
				<div class="wrapper action-mask">
					<div class="action" bind:this={callToAction}>
						<div class="mask">
							{#await loadImage("assets/imgs/scroll_arrow.png") then src}
								<img src="{src}" alt="">
							{/await}
						</div>
						<div>
							scroll
						</div>
					</div>
				</div>
			</div>

			<div class="parallax-wrapper home-back" bind:this={backgroundContainer}>
				{#await loadImage("assets/imgs/home-back.jpg") then src}
					<img src="{src}" bind:this={backgroundImage} draggable="false" alt="Home Background" style="width:100%; height: 100%; object-fit: cover;">
				{/await}
			</div>
		</div>
	</div>
</div>

<style lang="sass">

@import "../consts.sass"
@include textStyles()

#content-container
	height: 100vh
	width: 100vw
	padding: 12vh 7vw
	box-sizing: border-box
	position: relative

	.content-wrapper
		position: relative
		height: 100%
		box-sizing: border-box
		z-index: 2

	.flex
		z-index: 2
		width: 95%
		height: 100%
		display: flex
		flex-direction: row
		justify-content: space-between
		position: relative
		box-sizing: border-box

		.flex-wrapper
			position: relative
			height: 100%
			display: flex
			flex-direction: column
			justify-content: center

			&.second
				margin-right: 5vw 
				justify-content: flex-end

			h1
				font-weight: 400

			.title-mask
				overflow: hidden
				display: inline-flex

			.mask
				overflow: hidden

			.h-signature
				width: 35vh
				margin-left: -6vh

			.occupation
				position: relative
				margin-top: 8vh

			.action-mask
				margin-top: 10vh
				margin-right: 7vw
				display: inline-flex
				overflow: hidden

				.action
					font-size: 2vh
					letter-spacing: 0.5vh
					font-family: $font
					text-transform: uppercase
					color: white
					position: relative
					display: inline-flex
					flex-direction: row
					align-items: center

					.mask
						overflow: hidden
						height: 2vh

						img
							height: 2.3vh
							margin-right: 1.5vh
							animation: scrollArrowLoop 3s ease infinite

	.parallax-wrapper
		position: absolute
		left: 0
		z-index: -1
		width: 80%
		height: 100%
		margin-left: 5%
		border-radius: 1.5vh
		overflow: hidden
		box-sizing: border-box
		-webkit-touch-callout: none
		-webkit-user-select: none
		-moz-user-select: none
		-ms-user-select: none
		user-select: none
		transition: box-shadow 0.6s ease
		-webkit-transition: box-shadow 0.6s ease

		@media only screen and (max-width: 1250px)
			&
				opacity: 0.7

		@media only screen and (max-width: 750px)
			&
				opacity: 0.3

		img
			height: 100%
			width: 100%
			object-fit: cover
			border-radius: 1.5vh

@media only screen and (min-width: 1250px)
	.h-signature
		display: block

	.occupation
		width: 100%

	#content-container .flex *
		text-align: left

@media only screen and (max-width: 1250px)
	#content-container .flex *
		text-align: left

	.flex
		justify-content: center !important
		width: 100% !important

		.flex-wrapper 
			&.first
				display: none !important

			&.second
				justify-content: center !important
				margin: 0

	#content-container .flex .bottom
		text-align: left
		left: 5vw

	.parallax-wrapper
		width: 100% !important
		margin-left: 0 !important

@media only screen and (max-width: 750px)
	.occupation
		width: 70%


#signature
	.path-1
		stroke-dasharray: 2063.8896484375
		stroke-dashoffset: 2063.8896484375


@keyframes scrollArrowLoop
	0%
		transform: translateY(-120%)
	
	30%
		transform: translateY(0%)
	
	70%
		transform: translateY(0%)
	
	100%
		transform: translateY(120%)

</style>